/*
 * @Author: zhangsusha@58.com
 * @LastEditors: zhangsusha
 * @LastEditTime: 2022-04-06 17:51:44
 * @FilePath: /ershoufang-common-nuxt/pages/old/home/components/recommend/item.js
 * @Description:
 * @Date: 2022-04-06 14:22:32
 * Copyright (c) 2022 by zhangsusha/五八, All Rights Reserved.
 */
import DATA from './item.json';
import { getStaticUrl } from '@/utils/env';
import { mapGetters } from 'vuex';

const config = DATA.Config;

export default {
    name: 'recommendItem',
    props: {
        value: {
            type: Object
        },
        fromSoj: {
            type: String,
            default: ''
        },
        type: {
            default: 'KLYK',
            type: String
        },
        sojParams: {
            default: '',
            type: String
        },
        isAd: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            pano_icon: getStaticUrl('/site/img/common/esf_list_icon_quanjing@3x.png'),
            video_icon: getStaticUrl('/site/img/common/esf_list_icon_shipin@3x.png'),
            zszs_icon: getStaticUrl('/touch/img/m_detail/esf_list_icon_zszs.png'),
            youpin_icon: getStaticUrl('/pc/ajk/esf_list_icon_youpin_gold@3x.png'),
            isExtraSkuShow: false
        };
    },
    computed: {
        ...mapGetters({
            request: 'getRequest'
        }),
        isApp() {
            const app = this.request.isFromApp;
            if (app === 'i-broker2' || app === 'a-broker') {
                return false;
            }
            return app;
        },
        config() {
            return config[this.type];
        },
        community() {
            return this.value.community;
        },
        property() {
            return this.value.property;
        },
        imageBlank() {
            if (Number(this.value.property.origin_adjust)) {
                return this.value.property.origin_width > this.value.property.origin_height ? 'widthFit' : 'heightFit';
            } else {
                return ''
            }
        },
        broker() {
            return this.value.broker;
        },
        other() {
            return this.value.other || {};
        },
        attribute() {
            return this.property.attribute;
        },
        cp() {},
        ep() {
            return {
                name: this.fromSoj,
                ...this.value.sojInfo
            };
        }
    },
    methods: {}
};
